import { Partytown } from '@builder.io/partytown/react';
import { FC } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Layout from '../../components/layout';
import { ROUTE_CONSTANTS } from '../../constants/RouteConstants';
import { getBaseHref } from '../environment';

export const BASE_HREF = getBaseHref();

const router = createBrowserRouter(
   Object.values(ROUTE_CONSTANTS).map((route) => ({
      path: route.path,
      element: <Layout {...route} />,
   })),
   {
      basename: BASE_HREF,
   }
);

export const Routing: FC = () => {
   return (
      <>
         <Partytown forward={['dataLayer.push', 'gtag']} />
         <RouterProvider router={router} />
      </>
   );
};
